//@ts-ignore
import("./bootstrap");
